import React, { useState } from "react";
import { Button } from "../Shared/Buttons/Button";
import { ReactComponent as LeftArrow } from "../../assets/svg/left_arrow.svg";
import { useMediaQuery } from "react-responsive";
import { Candidate } from "../../models/Candidate";
import { Tabs } from "../Shared/Tabs";
import { LazyProfileImage } from "../Shared/LazyProfileImage";

interface Props {
    style: any;
    selectedCandidate: Candidate;
    tabItems: any;
    onClose: () => void;
}

export const TabPanel: React.FC<Props> = (props) => {
    const styles = props.style;
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const [activeTab, setActiveTab] = useState<string>("profile");
    
    return (
        <div style={styles.content}>
            {isMobile && <div style={styles.backButton} onClick={() => props.onClose()}>
                <Button style={styles.backButton.button}><LeftArrow style={styles.backButton.icon} /></Button>
                <span style={styles.backButton.text}>{"Back"}</span>
            </div>}
            <div>
                {props.selectedCandidate && <div style={styles.profileContainer}>
                    <LazyProfileImage
                        candidateId={props.selectedCandidate.candidateId}
                        style={styles.profileImage}
                    />
                    <div style={styles.detailsWrapper}>
                        <div style={styles.detailsWrapper.name}>{props.selectedCandidate.forename} {props.selectedCandidate.surname}</div>
                        <div style={styles.detailsWrapper.recentEmployer}>
                            {props.selectedCandidate.recentJobTitle && <div>{props.selectedCandidate.recentJobTitle}</div>}
                            {props.selectedCandidate.recentEmployer && <div>{"at " + props.selectedCandidate.recentEmployer}</div>}
                        </div>
                        {props.selectedCandidate.preferredRole && <div style={styles.detailsWrapper.preferredRole}>
                            <span style={styles.detailsWrapper.preferredRole.bold}>{"Prefer : "}</span>{props.selectedCandidate.preferredRole}
                        </div>}
                    </div>
                </div>}
                {props.tabItems.length > 0 && (
                    <Tabs 
                        styles={styles.tabs} 
                        tabItems={props.tabItems} 
                        selectedTab={activeTab}
                        getSelectedTab={setActiveTab}
                    />
                )}
            </div>
        </div>
    )
}